// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 177 ? "home" : chunkId) + "-legacy." + {"33":"84229ca7","177":"2014cb02","324":"b73b7306","326":"3574b5e7","531":"f1e87b84","553":"4f15ede6","665":"2f5e931c"}[chunkId] + ".js";
};